/* tslint:disable */
/* eslint-disable */
/**
 * My App
 * This is an awesome app!
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TodoInput
 */
export interface TodoInput {
    /**
     * 
     * @type {string}
     * @memberof TodoInput
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof TodoInput
     */
    isDone: boolean;
}

/**
 * Check if a given object implements the TodoInput interface.
 */
export function instanceOfTodoInput(value: object): value is TodoInput {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('isDone' in value) || value['isDone'] === undefined) return false;
    return true;
}

export function TodoInputFromJSON(json: any): TodoInput {
    return TodoInputFromJSONTyped(json, false);
}

export function TodoInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): TodoInput {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'isDone': json['isDone'],
    };
}

export function TodoInputToJSON(json: any): TodoInput {
    return TodoInputToJSONTyped(json, false);
}

export function TodoInputToJSONTyped(value?: TodoInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'isDone': value['isDone'],
    };
}

